module.exports = __webpack_public_path__ + "static/img/grunt.f6c3f60f.png";